import * as t from "react";
import r from "../lib/SSRBase.es.js";
import m from "../defs/Chat.es.js";
const o = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(r, { ref: e, ...a, weights: m }));
o.displayName = "ChatIcon";
const f = o;
export {
  f as Chat,
  o as ChatIcon
};
